import { render, staticRenderFns } from "./LAnding.vue?vue&type=template&id=5b508806&scoped=true"
import script from "./LAnding.vue?vue&type=script&lang=js"
export * from "./LAnding.vue?vue&type=script&lang=js"
import style0 from "./LAnding.vue?vue&type=style&index=0&id=5b508806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b508806",
  null
  
)

export default component.exports